import React from "react"
import styled, { css } from "styled-components"

import { Img } from "wordsby-components"

import Typography from "@material-ui/core/Typography"

import IoAnimator from "../../IoAnimator"

import House from "../../../../static/icons/property-managers.svg"
import Apartment from "../../../../static/icons/multi-unit-managers.svg"
import People from "../../../../static/icons/insurance-professionals.svg"

import * as theme from "../../../theme"

const Single = ({ image, headline, description, icon, ...rest }) => {
  return (
    <Feature animation="fadeInUp" {...rest}>
      {icon === "house" ? (
        <House />
      ) : icon === "apartment" ? (
        <Apartment />
      ) : icon === "people" ? (
        <People />
      ) : (
        !!image && <Img field={image} />
      )}
      <Headline variant="h3" gutterBottom>
        {headline}
      </Headline>
      <Description variant="body1" gutterBottom>
        {description}
      </Description>
    </Feature>
  )
}

export default Single

const Feature = styled(IoAnimator)`
  ${props =>
    props.count &&
    css`
      @media (min-width: 940px) {
        width: ${100 / props.count}%;
      }
    `}
  @media (min-width: 940px) {
    padding: 40px 20px 30px 20px;
    margin: 0 12px;
  }
  padding: 40px 20px 30px 20px;
  margin: 12px 0;
  background: white;
  border-radius: 10px;
  text-align: center;
  svg {
    height: 18vw;
    max-height: 250px;
  }
`
const Headline = styled(Typography)`
  color: ${theme.color.primary};
  margin-top: 30px;
`
const Description = styled(Typography)``
